import React from 'react';
import CourseCard from './CourseCard';
import './CourseList.css';

function CourseList({ courses, onEnroll }) {
  return (
    <div className="course-list" id="courses">
      <div className="course-grid">
        {courses.map((course) => (
          <CourseCard key={course.id} course={course} onEnroll={onEnroll} />
        ))}
      </div>
    </div>
  );
}

export default CourseList;
